import { createIcon } from "../create-icon"

export const PreviousIcon = createIcon({
  title: "PreviousIcon",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.2996 11.7603C10.5814 11.4568 10.5639 10.9823 10.2603 10.7004L7.35221 8L10.2603 5.29959C10.5639 5.01774 10.5814 4.54319 10.2996 4.23966C10.0177 3.93612 9.54319 3.91855 9.23966 4.2004L5.73966 7.4504C5.58684 7.59231 5.5 7.79144 5.5 8C5.5 8.20855 5.58684 8.40768 5.73966 8.54959L9.23966 11.7996C9.54319 12.0814 10.0177 12.0639 10.2996 11.7603Z"
      fill="currentColor"
    />
  ),
})

PreviousIcon.displayName = "PreviousIcon"
